import { render } from "./SettingsPage.vue?vue&type=template&id=5e1409af"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"
script.render = render

export default script